<template>
  <section>
    <div class="row mt-4">
      <div class="col-12">
        <h4 class="pb-2">{{ $t('message.booking.new_booking.subscription_title') }}</h4>
        <div class="d-flex align-items-stretch text-center">
          <div class="col-6 card card-body flex-items mr-1 pointer-item shadow-sm"
               :class="{'panel-service-active': subscriptionTypeId === 1}"
               @click="$parent.applySubscription(1)">
            <div class="text-primary text-remark">
              {{ $t('message.booking.new_booking.subscription') }}
            </div>
            <label class="mt-4">{{ $t('message.subscription.every_2_weeks') }}</label>
            <div class="mt-4 text-remark text-pink">{{ $t('message.subscription.save_5') }}</div>
          </div>
          <div class="col-6 card card-body flex-items ml-1 pointer-item shadow-sm"
               :class="{'panel-service-active': subscriptionTypeId === 2}"
               @click="$parent.applySubscription(2)">
            <div class="text-primary text-remark">
              {{ $t('message.booking.new_booking.subscription') }}
            </div>
            <label class="mt-4">{{ $t('message.subscription.weekly') }}</label>
            <div class="mt-4 text-remark text-pink mt-auto">{{ $t('message.subscription.save_7') }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      subscriptionTypeId: Number
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/newSteps/components/SubscriptionType.vue